/**
 * Web Style Import
 *
 */

import './dnb-field-block.scss'
